import { cx } from "./ui";

/**
 * The one place an invoice status is given a colour and a label.
 *
 * The badge reads ``display_status``, so a live invoice past its due date reads
 * "Overdue" even though ``overdue`` is never stored (FR-23.4). List and detail
 * share this so the two never disagree about what a status looks like.
 */
const TONE: Record<string, string> = {
  draft: "bg-slate-100 text-slate-600 ring-slate-500/20",
  sent: "bg-sky-50 text-sky-700 ring-sky-600/20",
  part_paid: "bg-amber-50 text-amber-700 ring-amber-600/20",
  paid: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  overdue: "bg-rose-50 text-rose-700 ring-rose-600/20",
  void: "bg-slate-100 text-slate-700 ring-slate-400/20",
};

const LABEL: Record<string, string> = {
  draft: "Draft",
  sent: "Sent",
  part_paid: "Part paid",
  paid: "Paid",
  overdue: "Overdue",
  void: "Void",
};

const FALLBACK_TONE = "bg-slate-100 text-slate-600 ring-slate-500/20";

/** The human label for a status, so a filter pill and a badge never disagree. */
export function invoiceStatusLabel(status: string): string {
  return LABEL[status] ?? status;
}

export function InvoiceStatusBadge({ status }: { status: string }) {
  return (
    <span
      className={cx(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset",
        TONE[status] ?? FALLBACK_TONE,
      )}
    >
      {LABEL[status] ?? status}
    </span>
  );
}
